(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["FAQs"] && !Shopify.designMode) return;
  try {
    

  $(document).on('click' , '.faq-titlees' , function(){
   $(this).closest('.faq-wrapss').toggleClass('faqss-active');
    $(this).next('.faq-bodys').slideToggle(); 
});
  

  } catch(e) { console.error(e); }
})();
})();
